module.exports = __webpack_public_path__ + "mobile_background-5fa905af491fe9f4438059ad0f12b5b4.png";